import { Navigate, NavigateProps, useLocation } from 'react-router';

const Redirect = (props: NavigateProps) => {
  const { state } = useLocation();

  return <Navigate state={state} {...props} />;
};

export default Redirect;
